module.exports = __webpack_public_path__ + "static/media/GilroyExtra-Bold.9070ffce.woff2";